import { AutoMap } from '@automapper/classes';

export class PlageHoraireEntity {
    Id?: number;
    @AutoMap()
    Debut!: string;
    @AutoMap()
    Fin!: string;
}
